import React from "react";
import "../style/footeruser.css";
import { useNavigate } from "react-router-dom";

const FooterUser = ({ location }) => {
  const navigate = useNavigate();

  const handleNavigate = (goto) => {
    navigate(goto);
  };
  return (
    <footer className="custom-con-footer d-flex justify-content-center align-items-center">
      <div className="custom-con-content-footer">
        <div className="d-flex justify-content-center align-items-center">
          <a
            href="https://www.instagram.com/cuttingedge.academy/"
            target="_blank"
          >
            <i className=" custom-icon-social bi bi-instagram"></i>
          </a>
          <a href="https://wa.me/628984001333" target="_blank">
            <i className="custom-icon-social bi bi-whatsapp"></i>
          </a>
        </div>
        <div className="d-flex justify-content-center align-content-center">
          <p
            className={
              location.pathname === "/"
                ? "custom-text-footer-active"
                : "custom-text-footer"
            }
            onClick={() => handleNavigate("/")}
          >
            Home
          </p>
          <p
            className={
              location.pathname === "/about"
                ? "custom-text-footer-active"
                : "custom-text-footer"
            }
            onClick={() => handleNavigate("/about")}
          >
            About
          </p>
          <p
            className={
              location.pathname === "/courses"
                ? "custom-text-footer-active"
                : "custom-text-footer"
            }
            onClick={() => handleNavigate("/courses")}
          >
            Courses
          </p>
          <p
            className={
              location.pathname === "/programs"
                ? "custom-text-footer-active"
                : "custom-text-footer"
            }
            onClick={() => handleNavigate("/programs")}
          >
            Programs
          </p>
          <p
            className={
              location.pathname === "/scholarshipinfo"
                ? "custom-text-footer-active"
                : "custom-text-footer"
            }
            onClick={() => handleNavigate("/scholarshipinfo")}
          >
            Scholarship
          </p>
          <p
            className={
              location.pathname === "/alumni"
                ? "custom-text-footer-active"
                : "custom-text-footer"
            }
            onClick={() => handleNavigate("/alumni")}
          >
            Alumni
          </p>
          <p
            className={
              location.pathname === "/contactus"
                ? "custom-text-footer-active"
                : "custom-text-footer"
            }
            onClick={() => handleNavigate("/contactus")}
          >
            Contact
          </p>
        </div>
        <div className="d-flex justify-content-center align-content-center">
          <p className="custom-text-copyright-footer">
            Cutting Edge Academy | All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterUser;
